export default "__VITE_ASSET__Blu3mXT5__"